// Assets shown under a newer ticker than the one the platform stores. MATIC
// was renamed POL in the Polygon migration; the backend already prices it as
// POL on venues that only list the new ticker.
//
// Display only. Stored symbols, API values and TRADING_SYMBOLS keep the old
// ticker: a call's fingerprint (provenance.call_payload) hashes "symbol", so
// renaming the stored value would break every published MATIC fingerprint.
const RENAMED_BASES: Record<string, string> = {
  MATIC: 'POL',
}

/** "MATIC/USDT" -> "POL/USDT", "MATIC" -> "POL"; any other symbol unchanged. */
export const displaySymbol = (symbol: string): string => {
  const [base, ...rest] = symbol.split('/')
  const renamed = RENAMED_BASES[base.toUpperCase()]
  return renamed ? [renamed, ...rest].join('/') : symbol
}

/** The base asset as shown: "MATIC/USDT" -> "POL". */
export const displayBase = (symbol: string): string => displaySymbol(symbol).split('/')[0]

/** True when the shown symbol differs from the stored one. */
export const isRenamedSymbol = (symbol: string): boolean => displaySymbol(symbol) !== symbol

/**
 * For records, where the stored value matters: "POL/USDT (recorded as
 * MATIC/USDT)". Unrenamed symbols are returned as they are.
 */
export const recordedSymbol = (symbol: string): string =>
  isRenamedSymbol(symbol) ? `${displaySymbol(symbol)} (recorded as ${symbol})` : symbol
